import { render, staticRenderFns } from "./Attempt2.vue?vue&type=template&id=415e810a&scoped=true&"
import script from "./Attempt2.vue?vue&type=script&lang=js&"
export * from "./Attempt2.vue?vue&type=script&lang=js&"
import style0 from "./Attempt2.vue?vue&type=style&index=0&id=415e810a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415e810a",
  null
  
)

component.options.__file = "Attempt2.vue"
export default component.exports